// extracted by mini-css-extract-plugin
export default {"userProfilePage":"UserProfilePage_userProfilePage__-RrRP","profileSection":"UserProfilePage_profileSection__BXuZP"};